// 多主题色 vuex 模块
const state = () => ({
    currentTheme: localStorage.getItem('theme') || 'default',
    themes: {
        default: {
            primary: '#626aef',
            sidebar: '#ffffff',
            background: '#f6f8fc',
            menuText: '#333333',
            menuActiveText: '#626aef'
        },
        mint: {
            primary: '#22c55e',
            sidebar: '#ffffff',
            background: '#f0fdf4',
            menuText: '#333333',
            menuActiveText: '#22c55e'
        },
        coral: {
            primary: '#f97316',
            sidebar: '#ffffff',
            background: '#fff7ed',
            menuText: '#333333',
            menuActiveText: '#f97316'
        },
        lavender: {
            primary: '#a855f7',
            sidebar: '#ffffff',
            background: '#faf5ff',
            menuText: '#333333',
            menuActiveText: '#a855f7'
        },
        ocean: {
            primary: '#0ea5e9',
            sidebar: '#ffffff',
            background: '#f0f9ff',
            menuText: '#333333',
            menuActiveText: '#0ea5e9'
        }
    }
})

const mutations = {
    SET_THEME(state, theme) {
        state.currentTheme = theme
        localStorage.setItem('theme', theme)
        const root = document.documentElement
        const themeConfig = state.themes[theme]
        root.style.setProperty('--el-color-primary', themeConfig.primary)
        root.style.setProperty('--sidebar-bg-color', themeConfig.sidebar)
        root.style.setProperty('--main-bg-color', themeConfig.background)
        root.style.setProperty('--menu-text-color', themeConfig.menuText)
        root.style.setProperty('--menu-active-text-color', themeConfig.menuActiveText)
    }
}

const actions = {
    setTheme({ commit }, theme) {
        commit('SET_THEME', theme)
    }
}

const getters = {
    currentTheme: state => state.currentTheme,
    themes: state => state.themes
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
} 